import { computed, type ComputedRef, type Ref, toRef } from 'vue'
import { type StoneImage, useStoneImage } from '@/domain/stone/useStoneImage'
import type { MonolithImageSizeFragment } from '@/graphql/api'
import type { RingBuilder } from '@/plugins/ring-builder.ts'

export function useEngagementRing3rdStep(ringBuilder: RingBuilder): {
    ringBuilderRingImage: Readonly<
        Ref<
            | {
                  small_x2: MonolithImageSizeFragment
                  large_x2: MonolithImageSizeFragment
              }
            | undefined
        >
    >
    ringBuilderRingDescription: ComputedRef<string>
    ringBuilderStoneDescription: ComputedRef<string>
    ringBuilderStoneImage: ComputedRef<StoneImage | undefined>
    ringBuilderSignatureStoneImg: Readonly<Ref<string | undefined>>
    ringBuilderSignatureStoneDescription: Readonly<Ref<string>>
} {
    const {
        ring: ringBuilderRing,
        stone: ringBuilderStone,
        stoneShapeAndWeight,
        stoneDescription,
        stonePrice,
        ringTotalSaleAmountFormatted: ringBuilderRingTotalSaleAmountFormatted,
        mountFragment,
        image,
    } = ringBuilder

    const ringBuilderRingDescription = computed(
        () =>
            `${ringBuilderRing.value?.primaryMetal.translation.name} ${ringBuilderRing.value?.productName}: ${ringBuilderRingTotalSaleAmountFormatted.value}`
    )

    const ringBuilderStoneDescription = computed(
        () =>
            `${stoneShapeAndWeight.value} ${stoneDescription.value}: ${stonePrice.value}`
    )

    const ringBuilderStoneImage = useStoneImage(ringBuilderStone)

    const ringBuilderSignatureStoneImg = toRef(
        () => mountFragment.value?.signatureStone?.image
    )
    const ringBuilderSignatureStoneDescription = toRef(() => {
        if (
            mountFragment.value?.signatureStone?.crystal.systemCode ===
            'DIAMOND'
        ) {
            return `${mountFragment.value?.signatureStone.crystal.translation.name} signature stone`
        }
        return `${mountFragment.value?.signatureStone?.color.translation.name} ${mountFragment.value?.signatureStone?.crystal.translation.name} signature stone`
    })

    return {
        ringBuilderRingImage: image,
        ringBuilderRingDescription,
        ringBuilderStoneDescription,
        ringBuilderStoneImage,
        ringBuilderSignatureStoneImg,
        ringBuilderSignatureStoneDescription,
    }
}
